import React, { useCallback, useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import { customSelectStyle } from "../../../_metronic/_partials/dropdowns/ReactSelectCustomStyle";
import { getUsers } from "../../api";
import * as S from "./Users.styles";
import { columns } from "./columns";
import { LINK_TYPE_OPTIONS, STATUS_OPTIONS } from "./constants";

const Users = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);

  const [filters, setFilters] = useState({
    name: "",
    email: "",
    linkType: null,
    status: null,
  });

  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
  });

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getUsers({
        page: pagination.page,
        perPage: pagination.perPage,
        name: filters.name,
        email: filters.email,
        linkType: filters.linkType?.id,
        status: filters.status?.id,
      });

      setData(response.data.data);
      setTotalRows(response.data.total);
    } finally {
      setLoading(false);
    }
  }, [pagination, filters]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
    setPagination((prev) => ({ ...prev, page: 1 }));
  };

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, page }));
  };

  const handlePerPageChange = (newPerPage, page) => {
    setPagination({ page, perPage: newPerPage });
  };

  const subHeaderComponent = useMemo(() => (
    <S.FiltersContainer>
      <p>Filtrar por:</p>
      <S.FiltersWrapper>
        <div>
          <S.Input
            type="text"
            placeholder="Nome"
            className="form-control"
            value={filters.name}
            onChange={(e) => handleFilterChange("name", e.target.value)}
          />
        </div>
        <div>
          <S.Input
            type="text"
            placeholder="Email"
            className="form-control"
            value={filters.email}
            onChange={(e) => handleFilterChange("email", e.target.value)}
          />
        </div>
        <div>
          <S.CustomSelect
            name="link_type_select"
            isSearchable={false}
            options={LINK_TYPE_OPTIONS}
            theme={customSelectStyle}
            onChange={(option) => handleFilterChange("linkType", option)}
            value={filters.linkType}
            placeholder="Vínculo"
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            hideSelectedOptions
            isClearable
          />
        </div>
        <div>
          <S.CustomSelect
            name="status_select"
            isSearchable={false}
            options={STATUS_OPTIONS}
            theme={customSelectStyle}
            onChange={(option) => handleFilterChange("status", option)}
            value={filters.status}
            placeholder="Status"
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            hideSelectedOptions
            isClearable
          />
        </div>
      </S.FiltersWrapper>
    </S.FiltersContainer>
  ), [filters]);

  return (
    <>
      <h1 className="azul-cabecalho">USUÁRIOS</h1>
      <p className="subheader-text mb-10">Listagem de todos os usuários</p>

      <div className="row mb-10">
        <DataTable
          columns={columns}
          data={data}
          progressPending={loading}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerPageChange}
          subHeader
          subHeaderComponent={subHeaderComponent}
        />
      </div>
    </>
  );
};

export default Users;
